import { render, staticRenderFns } from "./project-input.vue?vue&type=template&id=51be6f05&scoped=true&"
import script from "./project-input.vue?vue&type=script&lang=js&"
export * from "./project-input.vue?vue&type=script&lang=js&"
import style0 from "./project-input.vue?vue&type=style&index=0&id=51be6f05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be6f05",
  null
  
)

export default component.exports